module.exports = __webpack_public_path__ + "static/img/45烘培.15aa2ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo/45烘培.jpg
// module id = qyEb
// module chunks = 0